import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { IOption } from 'src/app/types/option';

/**
 * Sort Select Component
 * @export
 * @class SortSelectComponent
 * @typedef {SortSelectComponent}
 */
@Component( {
    selector: 'riege-sort-select',
    templateUrl: './sort-select.component.html',
    styleUrl: './sort-select.component.scss',
    imports: [MatFormField, MatSelectModule],
    standalone: true
} )
export class SortSelectComponent {
    /**
     * options
     * @type {IOption[]}
     */
    @Input() options: IOption[] = [];
    /**
     * selected Option
     * @type {?string}
     */
    @Input() selectedOption?: string;

    /**
     * sort Changed event Emitter
     * @readonly
     * @type {*}
     */
    @Output() readonly sortChanged = new EventEmitter();

    /**
     * sort data by given property and order
     * @param {(string | string[])} sort
     */
    sortBy( sort: string | string[] ) {
        this.sortChanged.emit( sort );
    }
}
